// extracted by mini-css-extract-plugin
export default {"wrapper":"credits_wrapper__XPF9t","link":"credits_link__dgiCj"};